import { BandsInTownWidget } from './BandsInTownWidget';
import { PageHeader } from './PageHeader';
import { ContactCTA } from './ContactCTA';

export function ShowsPage() {
    return (
        <div className="w-full py-12">
            <PageHeader title="Upcoming Shows" />

            {/* Bandsintown Widget */}
            <div className="max-w-6xl mx-auto px-4 mb-12">
                <BandsInTownWidget />
            </div>

            <ContactCTA
                title="Want to book us?"
                description="Send us an email for booking inquiries and venue partnerships."
            />
        </div>
    );
}
